import React from 'react';
import styled from 'styled-components';
import { breakpoints } from '@avangard/ui/utils';

type TestingPlaceholderProps = {
    image: React.ReactElement;
    content: React.ReactElement;
    actions: React.ReactElement | null;
};

const Root = styled.div`
    width: 100%;
    max-width: 600px;
`;

const Image = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 405px;
    margin: 0 auto 20px auto;

    img {
        width: 100%;
        display: inline-block;
    }
`;

const Content = styled.div`
    font-size: 1.4rem;
    text-align: center;
    line-height: 1.6;
`;

const Actions = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;

    > * {
        &:not(:last-child) {
            margin-inline-end: 10px;
        }
    }

    ${breakpoints.down('xs')} {
        flex-direction: column;

        > * {
            width: 100%;
            text-align: center;

            &:not(:last-child) {
                margin-inline-end: 0;
                margin-bottom: 12px;
            }
        }
    }
`;

const TestingPlaceholder = (props: TestingPlaceholderProps): React.ReactElement => {
    const { image, content, actions } = props;

    return (
        <Root>
            <Image>{image}</Image>
            <Content>{content}</Content>
            {actions ? <Actions>{actions}</Actions> : null}
        </Root>
    );
};

export { TestingPlaceholder };
